
function setLastActivity() {
  localStorage.setItem("last_activity_at", Date.now());
}

function getLastActivity() {
  const ts = localStorage.getItem("last_activity_at");
  return ts ? parseInt(ts, 10) : null;
}

function getIdleTimeout() {
  
  // idle_timeout is stored in minutes
  const idleTimeout = localStorage.getItem("idle_timeout");
  // console.log(idleTimeout, "====IDLEEE");
  return idleTimeout ? parseInt(idleTimeout, 10) : null; // default 15 min
}

export function setupIdleManager(onIdle) {
  const activityEvents = ['mousemove', 'keydown', 'mousedown', 'touchstart'];

  function activityHandler() {
    setLastActivity();
  }

  for (let i = 0; i < activityEvents.length; i++) {
    window.addEventListener(activityEvents[i], activityHandler);
  }

  // Set initial activity time
  setLastActivity();
  const interval = setInterval(function () {
    const lastActivity = getLastActivity();
    const idleTimeout = getIdleTimeout();
    // console.log("TIMEOUT===", idleTimeout, "===LAST ACTIVITY",lastActivity);

    if (lastActivity && idleTimeout && !isNaN(idleTimeout)) {
      const now = Date.now();
      if (now - lastActivity > idleTimeout * 60 * 1000) {
        onIdle();
        clearInterval(interval);
        for (let i = 0; i < activityEvents.length; i++) {
          window.removeEventListener(activityEvents[i], activityHandler);
        }
      }
    } else {
      "No idle setting"
    }
  }, 1000);

  return function () {
    clearInterval(interval);
    for (let i = 0; i < activityEvents.length; i++) {
      window.removeEventListener(activityEvents[i], activityHandler);
    }
  };
}